"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.meta = exports.numberField = exports.field = exports.isValueType = exports.normalizePosition = void 0;
var util_1 = require("remota-common/util");
function normalizePosition(plain) {
    if (plain === null || plain === undefined || Array.isArray(plain)) {
        return undefined;
    }
    else if ("left_top" in plain) {
        return {
            leftTop: plain.left_top,
            rightBottom: plain.right_bottom,
        };
    }
    else if ("x1" in plain) {
        return {
            leftTop: { x: plain.x1, y: plain.y1 },
            rightBottom: { x: plain.x2, y: plain.y2 },
        };
    }
    else {
        return undefined;
    }
}
exports.normalizePosition = normalizePosition;
function isValueType(item) {
    return typeof item === "string" || typeof item === "number" || typeof item === "boolean" || item instanceof Date;
}
exports.isValueType = isValueType;
function field(value, position, confidence, readonly) {
    if (value === null) {
        return (0, util_1.omitUndefined)({ confidence: confidence, plainPosition: normalizePosition(position), readonly: readonly });
    }
    else if (value === undefined || isValueType(value)) {
        return (0, util_1.omitUndefined)({ plainValue: value, confidence: confidence, plainPosition: normalizePosition(position), readonly: readonly });
    }
    else {
        var vf = field(value.value, value.position, value.confidence, value.readonly);
        if (value.modifiedValue === undefined) {
            return vf;
        }
        // TODO: editedValueと補完された値を分ける
        return __assign(__assign({}, vf), { editedValue: value.modifiedValue });
    }
}
exports.field = field;
function numberField(value, position, confidence) {
    if (value === null) {
        return (0, util_1.omitUndefinedNumber)({ confidence: confidence, plainPosition: normalizePosition(position) });
    }
    else if (value === undefined || isValueType(value)) {
        return (0, util_1.omitUndefinedNumber)({ plainValue: value, confidence: confidence, plainPosition: normalizePosition(position) });
    }
    else {
        var vf = numberField(value.value, value.position, value.confidence);
        if (value.modifiedValue === undefined) {
            return vf;
        }
        // TODO: editedValueと補完された値を分ける
        return __assign(__assign({}, vf), { editedValue: value.modifiedValue });
    }
}
exports.numberField = numberField;
function meta(value) {
    return { meta: true, plainValue: value };
}
exports.meta = meta;
